import { useEffect, useState } from "react";

import { REACT_APP_ARPS_BASE_URL } from "../../../utils/urls";
import formatMoney from "../../../utils/formatMoney";
import OperatorDetails from "./OperatorDetails";
import { Spin, Table } from "antd";
import { ceil, keys } from "lodash";
import getOperatorsRevenues from "../../../utils/getOperatorsRevenue";

export default function RevenueByOprt({ startDate, endDate }: any) {
  const [showDetails, setShowDetails] = useState(false);
  const [revenues, setRevenues] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState();
  const operators: any = {
    "0113": "Samweli Kitomari",
    "0069": "Anna Mzori",
    "0005": "Fatuma Suleiman",
    "0104": "Noela Soka",
    "0006": "Anna Chaulo",
    "0027": "Diana Laizer",
    "0004": "Juliana Sendwa",
    "0048": "Consolata Begina",
    "0112": "Ruth Kulindwa",
    // "0001": "0001",
    // "0002": "John Doe",
    // "0011": "John Doe",
    // "0023": "John Doe",
    // "0052": "John Doe",
    // "0040": "John Doe",
    // "0041": "John Doe",
    // "0042": "John Doe",
    // "0044": "John Doe",
  };

  const raw = keys(operators);

  const fetchRevenues = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/revenue/workshop/operator?start=${startDate}&end=${endDate}`
    );
    const data = await response.json();
    const rawData = data.filter((item: any) => raw.includes(item._id));

    const cleaned = await getOperatorsRevenues(rawData);

    setRevenues(cleaned);
    setLoading(false);
  };

  useEffect(() => {
    fetchRevenues();
  }, [startDate]);

  const columns = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Name",
      width: 100,
      render: (record: any) => (
        <span className="text-gray-700">
          {operators[record._id] ?? record._id}
        </span>
      ),
    },

    {
      title: "Hours Sold",
      width: 50,
      render: (record: any) => (
        <span className="text-gray-700">{ceil(record.hours_sold, 2)}</span>
      ),
    },
    {
      title: "Revenue",
      width: 80,
      render: (record: any) => (
        <span className="text-gray-700">{formatMoney(record.net)}</span>
      ),
    },
  ];

  const filtered = revenues.filter(
    (revenue: any) =>
      revenue._id !== "Cresencia" &&
      revenue._id !== "Fatuma" &&
      revenue._id !== "Swati"
  );

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center flex-1 mt-8">
        <Spin />
      </div>
    );
  }

  return (
    <div className="">
      <Table
        size="small"
        columns={columns}
        dataSource={filtered}
        pagination={{ pageSize: 10 }}
        scroll={{ y: 550 }}
        rowKey="id"
        onRow={(r) => ({
          onClick: () => {
            setSelected(r);
            setShowDetails(true);
          },
        })}
      />

      <OperatorDetails
        isVisible={showDetails}
        setShowDetails={setShowDetails}
        selected={selected}
        services={revenues}
        startDate={startDate}
        endDate={endDate}
        operators={operators}
      />
    </div>
  );
}
